<template>
  <!-- Imporing Signature componet-->
  <HelloSignPage></HelloSignPage>
</template>
<script>
import HelloSignPage from "../../components/Profile/HelloSign.vue";
import { mapState } from "vuex";
export default {
  name: "HelloSign",
  components: {
    HelloSignPage,
  },
  computed: mapState(["attorney_data"]),
  mounted() {
    // If Attorney not signed in and direct come here throgh URL, It will redirect to UnAuthorized Page
     if(this.attorney_data==undefined || this.attorney_data==null || this.attorney_data=="" || this.attorney_data.error!=null){
       this.$toast.error("Please sign-in first!!");
       this.$router.push("/unauthorized");
     }
  },
};
</script>
